import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { SftpKeyService } from '../../core/sftp';
import { AddKeyDialogComponent } from './add-key.component';
import { DeleteKeyDialogComponent } from './delete-key.component';
import { DownloadKeyDialogComponent } from './download-key.component';
import { SftpKeyListComponent } from './key-list.component';

const routes: Routes = [
  {
    path: '',
    component: SftpKeyListComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatDialogModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    GalaxyPageModule,
  ],
  declarations: [SftpKeyListComponent, DownloadKeyDialogComponent, DeleteKeyDialogComponent, AddKeyDialogComponent],
  exports: [RouterModule],
  providers: [SftpKeyService],
})
export class SftpModule {}
